import { render, staticRenderFns } from "./Donasi.vue?vue&type=template&id=b5073a16"
import script from "./Donasi.vue?vue&type=script&lang=js"
export * from "./Donasi.vue?vue&type=script&lang=js"
import style0 from "./Donasi.vue?vue&type=style&index=0&id=b5073a16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports